import React, { useState } from 'react';
import Modal from 'react-modal';
import ShareCancellationModal from './ShareCancellationModal';
import axios from 'axios'; // 1. Added axios import

const ConfirmCancellationModal = ({
  isOpen,
  closeModal,
  eventData,
  addons,
  chosenPackage,
}) => {
  const [openShareCancelModal, setOpenShareCancelModal] = useState(false);
  const [isRefunding, setIsRefunding] = useState(false); // 2. Added loading state

  // 3. Added the Refund API Handler
  const handleCancelAndRefund = async () => {
    if (isRefunding) return; // Prevent double clicks
    
    // Safety check: Only attempt a Stripe refund if they actually paid
    if (eventData?.payment !== 'paid') {
      // If it's unpaid, just skip to the share modal (or call your standard cancel API)
      closeModal();
      setOpenShareCancelModal(true);
      return;
    }

    setIsRefunding(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/business/refund-payment`,
        { 
          eventId: eventData._id,
          refundReason: "requested_by_customer" 
        },
        { withCredentials: true }
      );

      if (response.data.success) {
        closeModal();
        setOpenShareCancelModal(true); // Open the next modal to notify the client
      }
    } catch (error) {
      console.error("Refund failed:", error);
      alert(error.response?.data?.message || "Failed to process refund. Please ensure the event has a valid Stripe payment.");
    } finally {
      setIsRefunding(false);
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal-content"
        style={{
          content: {
            width: '570px',
            height: 'auto', // Changed to auto to accommodate the tooltip
            margin: 'auto',
            padding: '30px',
          },
        }}
      >
        <span className="close" onClick={closeModal}>&times;</span>

        {/* Client Paid & Refund Box */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            background: '#FFFFFF',
            border: '1px solid #D9D9D9',
            borderRadius: '5px',
            marginBottom: '20px',
            padding: '20px',
          }}
        >
          <div>
            <div style={{ fontWeight: 'bold' }}>Client Paid</div>
            <div>${eventData?.expPaymentAmount}</div>
          </div>
          <div>
            <div style={{ fontWeight: 'bold' }}>Refund</div>
            <div>${eventData?.expPaymentAmount}</div>
          </div>
        </div>

        {/* Refund Details */}
        <h3 style={{ fontWeight: 'bold', marginBottom: '10px' }}>Refund Details</h3>
        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{chosenPackage?.name}</span>
            <span style={{ color: '#625C73', fontSize: '12px' }}>Full Refund</span>
          </div>
          <span>${chosenPackage?.cost}</span>
        </div>

        {addons?.map((addon, index) => (
          <div
            key={index}
            style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{addon?.name}</span>
              <span style={{ color: '#625C73', fontSize: '12px' }}>Full Refund</span>
            </div>
            <span>${addon?.cost}</span>
          </div>
        ))}

        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '15px', fontWeight: 'bold' }}>Transaction Fee (Stripe)</span>
            <span style={{ color: '#625C73', fontSize: '12px' }}>No Refund</span>
          </div>
          {/* Note: You have this hardcoded to $3.79, you may want to calculate this (2.9% + 30¢) later! */}
          <span>$3.79</span> 
        </div>

        {/* Total Refund */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontWeight: 'bold',
            marginTop: '20px',
            borderTop: '1px solid #ccc',
            borderBottom: '1px solid #ccc',
            paddingTop: '10px',
            paddingBottom: '10px'
          }}
        >
          <span>Total Refund</span>
          <span>${eventData?.expPaymentAmount}</span>
        </div>

        {/* 4. Added Disclaimer about Stripe Fees */}
        <div style={{ marginTop: '15px', padding: '10px', background: '#F9F9F9', borderLeft: '3px solid #260F99', fontSize: '12px', color: '#625C73' }}>
          <strong>Note:</strong> Refunds are processed immediately. As per standard payment processing rules, Stripe's original credit card processing fees are non-refundable and will be deducted from your available balance.
        </div>

        {/* Refund Note */}
        <p style={{ marginTop: '15px', fontWeight: 'bold' }}>Refund will be returned to client</p>
        <p style={{ color: '#625C73', fontSize: '14px' }}>Typically available within 5-10 business days</p>

        {/* Footer */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '30px',
          }}
        >
          <div style={{ fontSize: '14px', color: '#625C73' }}>2 / 3</div>

          {/* 5. Updated Cancel Booking Button */}
          <button
            onClick={handleCancelAndRefund}
            disabled={isRefunding}
            style={{
              background: isRefunding ? '#ccc' : 'transparent linear-gradient(90deg, #1C1154 0%, #211074 47%, #260F99 100%)',
              border: '1px solid #43425D',
              borderRadius: '4px',
              color: '#FFFFFF',
              fontSize: '15px',
              cursor: isRefunding ? 'not-allowed' : 'pointer',
              width: '210px',
              height: '45px',
            }}
          >
            {isRefunding ? 'Processing...' : 'Cancel Booking'}
          </button>
        </div>
      </Modal>

      {/* ShareCancellationModal (child modal) */}
      <ShareCancellationModal
        isOpen={openShareCancelModal}
        closeModal={() => setOpenShareCancelModal(false)}
        eventData={eventData}
      />
    </>
  );
};

export default ConfirmCancellationModal;